<app-de-wrapper *ngIf="!loading">
  <ng-container *ngIf="view === VIEW.CONFIRM">
    <h1 class="heading">Hej!</h1>
    <p class="info-text">
      I nästa steg får du koppla upp dig mot din bank och välja vilket konto du
      vill att betalningar ska dras ifrån.
    </p>
    <ng-container
      *ngIf="
        state.zaverProduct === ZAVERPRODUCT.TOKENIZED_ONBOARDING_WITH_PAYMENT
      "
    >
      <div class="details-wrapper">
        <hr class="details-divider" />

        <div class="details-container">
          <div class="details-key-entry">
            {{ state.paymentInformation?.title }}
          </div>
          <div class="details-value-entry">
            <zaver-button-link
              [text]="'Ditt köp'"
              (click)="toggleModal()"
            ></zaver-button-link>
          </div>
        </div>

        <hr class="details-divider" />

        <div class="details-container">
          <div class="details-key-entry">Totalbelopp</div>
          <div class="details-value-entry details">
            {{ state.totalCheckoutValue | value }}
          </div>
        </div>

        <hr class="details-divider" />
      </div>
    </ng-container>

    <div class="button-container">
      <zaver-primary-button
        [text]="'Välj bank & kontonummer'"
        (click)="confirm()"
      ></zaver-primary-button>
    </div>
  </ng-container>

  <ng-container *ngIf="view === VIEW.AIS">
    <iframe
      *ngIf="useIframe"
      class="iframe"
      scrolling="yes"
      [src]="trustlyUrl"
    ></iframe>
  </ng-container>
</app-de-wrapper>

<app-de-wrapper *ngIf="loading">
  <app-spinner></app-spinner>
</app-de-wrapper>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="'Stäng'"
  [title]="'Visa detaljer'"
  (onClose)="toggleModal()"
>
  <app-selector #selector [selectorItems]="selectorItems"></app-selector>
</zaver-checkout-modal>
